// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_iw","advertCardPhoto__image":"c-a_ix"};